//@ts-nocheck
import { useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  getToken,
  graphQLMutate,
  handleGraphQLErrors,
  REDIRECT_TIMEOUT_IN_SECONDS,
  setToken,
} from '../../utils'
import { LOCAL_STORAGE_ERROR_EMAIL_OAUTH, SESSION_STORAGE_OAUTH_EMAIL } from '../../utils/constants'
import { OAUTH_LOGIN_GET_TOKEN } from '../../graphql/mutations'

interface IOauthLoginGetToken {
  data: {
    authenticationExternalLogin: {
      token: string
    }
  }
}

export const useSignIn = ({
  login,
  password,
  token,
  oauthCode,
}: {
  login?: string
  password?: string
  token?: string
  oauthCode?: string
}) => {
  const formRef = useRef<HTMLFormElement>(null)
  const formAction = process.env.REACT_APP_SOMOS_SIGN_IN_URL || ''
  const redirectTimeOutRef = useRef<number | null>(null)
  const navigate = useNavigate()
  const urlRedirect = useMemo(() => window.location.origin, [])
  const [oauthEmail, setOauthEmail] = useState('')

  useEffect(() => {
    const checkTokenAndRedirect = () => {
      if (getToken()) {
        return formRef?.current?.submit()
      }

      if (!redirectTimeOutRef?.current) {
        return
      }

      // @ts-ignore
      redirectTimeOutRef.current = setTimeout(() => {
        checkTokenAndRedirect()
      }, 1000 * REDIRECT_TIMEOUT_IN_SECONDS)

      return () => {
        if (redirectTimeOutRef.current !== null) {
          clearTimeout(redirectTimeOutRef.current)
        }
      }
    }

    const checkOauthCodeAndRedirect = async () => {
      if (!oauthCode) {
        return
      }

      const email = sessionStorage.getItem(SESSION_STORAGE_OAUTH_EMAIL)

      if (!email) {
        return navigate('/logout')
      }

      setOauthEmail(email)

      sessionStorage.removeItem(SESSION_STORAGE_OAUTH_EMAIL)

      try {
        const {
          data: {
            authenticationExternalLogin: { token },
          },
        }: IOauthLoginGetToken = await graphQLMutate(OAUTH_LOGIN_GET_TOKEN, {
          variables: {
            code: oauthCode,
            email,
            provider: 'google',
          },
        })

        setToken(token)

        return formRef.current?.submit()
      } catch (error: any) {
        if (error?.graphQLErrors) {
          const errorData = handleGraphQLErrors(error.graphQLErrors)[0]

          const ssoError = {
            error: errorData,
            email: email,
          }

          localStorage?.setItem(LOCAL_STORAGE_ERROR_EMAIL_OAUTH, JSON.stringify(ssoError))
        }

        return navigate('/logout')
      }
    }

    if (oauthCode) {
      checkOauthCodeAndRedirect()
      return
    }

    if (!password || !login || !token) {
      return navigate('/logout')
    }

    setToken(token)

    return checkTokenAndRedirect()
  }, [login, navigate, oauthCode, password, token])

  return {
    formRef,
    formAction,
    urlRedirect,
    oauthEmail,
  }
}
